import { api } from '@/modules/api'
import * as types from '../mutation-types'

const state = {
  attendeeVoteReminders: [],
  attendeeVoteRemindersTotalPages: 0,
  attendeeVoteRemindersTotalItems: 0
}

const getters = {
  getAttendeeVoteReminders: state => state.attendeeVoteReminders,
  getAttendeeVoteRemindersTotalPages: state => state.attendeeVoteRemindersTotalPages,
  getAttendeeVoteRemindersTotalItems: state => state.attendeeVoteRemindersTotalItems
}

const actions = {
  async fetchAttendeeVoteReminders ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendeeVoteReminders.fetchReminders())
      commit(types.SET_AWARDS_REMINDERS, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to fetch attendee vote reminders')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateAttendeeVoteReminder ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendeeVoteReminders.updateReminder(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Attendee vote reminder was updated')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update attendee vote reminders')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_AWARDS_REMINDERS] (state, { attendeeVoteReminders, totalPages, totalItems }) {
    state.attendeeVoteReminders = attendeeVoteReminders
    state.attendeeVoteRemindersTotalItems = totalItems
    state.attendeeVoteRemindersTotalPages = totalPages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/attendee-vote-reminders.js